import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext.jsx';

export default function Setup() {
  const { completeSetup } = useAuth();
  const [form, setForm] = useState({ email: '', display_name: '', password: '' });
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await completeSetup({ ...form, email: form.email.trim() });
    } catch (err) {
      setError(err.message || 'Setup failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 px-4">
      <form
        onSubmit={submit}
        className="w-full max-w-md bg-white rounded-lg shadow-md p-6 space-y-4"
      >
        <h1 className="text-xl font-semibold text-cathay-700">First-run setup</h1>
        <p className="text-sm text-slate-600">
          Create the first administrator account. This page only appears when the
          database has no users.
        </p>
        <label className="block">
          <span className="text-sm text-slate-700">Email</span>
          <input
            type="email"
            required
            value={form.email}
            onChange={update('email')}
            className="mt-1 w-full border border-slate-300 rounded px-3 py-2 focus:border-cathay-500 focus:ring-1 focus:ring-cathay-500 outline-none"
          />
        </label>
        <label className="block">
          <span className="text-sm text-slate-700">Display name</span>
          <input
            type="text"
            required
            value={form.display_name}
            onChange={update('display_name')}
            className="mt-1 w-full border border-slate-300 rounded px-3 py-2 focus:border-cathay-500 focus:ring-1 focus:ring-cathay-500 outline-none"
          />
        </label>
        <label className="block">
          <span className="text-sm text-slate-700">Password (min 10 chars)</span>
          <input
            type="password"
            required
            minLength={10}
            value={form.password}
            onChange={update('password')}
            className="mt-1 w-full border border-slate-300 rounded px-3 py-2 focus:border-cathay-500 focus:ring-1 focus:ring-cathay-500 outline-none"
          />
        </label>
        {error && <div className="text-sm text-red-600">{error}</div>}
        <button
          type="submit"
          disabled={busy}
          className="w-full bg-cathay-500 hover:bg-cathay-600 disabled:opacity-60 text-white font-medium py-2 rounded transition"
        >
          {busy ? 'Creating…' : 'Create admin account'}
        </button>
      </form>
    </div>
  );
}
